import AnalyticsEvent from './analytics-event';
import { Product } from './segment-ecommerce-types';

/**
 * Where the product was viewed. The same `product.vue` component serves both the full
 * product page and the quick-view drawer, so without this the event cannot tell them
 * apart — which leaves any drawer-scoped view rate without a denominator.
 *
 * Deliberately narrower than `QuantityCounterSource`: a product view can only originate
 * from these two surfaces.
 */
export type ProductViewedComponent = 'product_page' | 'product_drawer';

export class ProductViewedEvent extends AnalyticsEvent {
  public readonly name = 'Product Viewed';

  constructor(public readonly properties: Product & { component: ProductViewedComponent }) {
    super();
  }
}

